module.exports = __webpack_public_path__ + "static/media/matte.bd3787cf.jpg";